import * as React from "react";
import Svg, { Rect, G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F9F9F9" />
      <G fillRule="evenodd" clipRule="evenodd" fill="#333">
        <Path d="M15.906 23.23a2 2 0 01-2-2V9a2 2 0 012-2H28a2 2 0 012 2v16.002a2 2 0 01-2 2h-3.64a1.886 1.886 0 01-1.886-1.886 1.886 1.886 0 00-1.886-1.885h-4.682zm.056-3.516a.256.256 0 100 .512h11.981a.256.256 0 100-.512h-11.98zm0-2.488a.256.256 0 000 .512h11.981a.256.256 0 000-.512h-11.98zm0-2.488a.256.256 0 100 .512h11.981a.256.256 0 100-.512h-11.98zm-.256-3.956c0-.953.773-1.725 1.725-1.725h9.043a1.725 1.725 0 010 3.45h-9.043a1.725 1.725 0 01-1.725-1.725z" />
        <Path d="M9 24.743a1 1 0 011-1h10.723a1 1 0 011 1v4.297a1 1 0 01-1 1H10a1 1 0 01-1-1v-4.297zm11.38 1.276a.256.256 0 000-.512h-1.768a.256.256 0 00-.256.256v2.257c0 .142.115.256.256.256h1.769a.256.256 0 000-.511h-1.204a.308.308 0 110-.617h1.204a.256.256 0 000-.512h-1.204a.308.308 0 110-.617h1.204zm-4.268-.256a.256.256 0 10-.512 0v2.257a.256.256 0 10.511 0c0-.286.317-.46.56-.306l.816.521a.255.255 0 10.274-.43l-.11-.07a1 1 0 010-1.686l.11-.07a.255.255 0 10-.274-.43l-.817.52a.363.363 0 01-.559-.306zm-6.026 2.257a.256.256 0 10.512 0c0-.481.39-.872.873-.872h.64a.256.256 0 100-.512h-1.205a.308.308 0 110-.617h1.204a.256.256 0 100-.512h-1.768a.256.256 0 00-.256.256V28.02zm2.775-.093a.255.255 0 10.476.186l.005-.012a.689.689 0 011.282 0l.005.012a.255.255 0 10.476-.186l-.879-2.243a.256.256 0 00-.481-.014l-.884 2.257zm1.122-.775a.184.184 0 110-.368.184.184 0 010 .368z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
